import { useState, useEffect, } from 'react';
import ImagePreloader from 'ImagePreloader';
import { Spin, message, } from 'antd';

export default function PreloadedImage(props) {
  const [loading, setLoading] = useState(true);
  const [src, setSrc] = useState('');
  const image = new Image();

  useEffect(() => {
    let isMounted = true;

    image.src = ImagePreloader.images[props.image].src;
    image.decode()
    .then(() => {
      setLoading(false);
      setSrc(image.src);
    })
    .catch((error) => {
      message.error(error.message);
      console.error(error, error.toString())
    });

    return () => { isMounted = false };
  }, []);

  return (
    <>
      {
        loading ?
        <Spin size="large" /> :
        <img style={{ width: props.width || "25vw" }} src={src} />
      }
    </>
  )
} 